<template>
  <div v-if="false">
    <PageHead title="医药费报销列表"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">报销单号：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入报销单号"
                v-model="queryForm.numberNo"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">报销年度：</div>
              <a-select
                allowClear
                placeholder="请选择报销年度"
                class="w200"
                v-model="queryForm.year"
              >
                <a-select-option
                  v-for="(item, index) in yearList"
                  :key="index"
                  :value="item"
                  >{{ item + '年度' }}</a-select-option
                >
              </a-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">表单状态：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.state"
              >
                <a-select-option
                  v-for="(item, index) in $store.state.app.formStatusList"
                  :key="index"
                  :value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>

      <div class="mb20 search-btns mt20">
        <a-button type="primary" @click="add(1)" icon="plus"> 申请</a-button>
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <span slot="disposalstate" slot-scope="text">{{ text }}</span>
        <div slot="type" slot-scope="text">
          <template v-if="text == 1">自助报销</template>
          <template v-if="text == 2">在职下单</template>
          <template v-if="text == 3">代客下单</template>
        </div>
        <div slot="state" class="statusDiv" slot-scope="text">
          <div :class="'dot' + text + ' mr5'"></div>
          <span
            v-for="(item, index) in $store.state.app.formStatusList"
            :key="index"
          >
            <span v-if="text == item['value']">{{ item.label }}</span>
          </span>
          <span></span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record, 1)">
            查看
          </a-button>

          <!-- <template v-if="record.state == 0">
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="add(record.id)">
              修改
            </a-button>
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="showDeleteConfirm(record.id)"
            >
              删除
            </a-button> </template
          ><a-divider type="vertical" v-if="record.recallButton" />
          <a-button
            v-if="record.recallButton"
            type="link"
            class="btn-link"
            @click="showRecallConfirm(record)"
          >
            撤回
          </a-button> -->
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="queryForm.page"
          :default-current="queryForm.page"
          :total="total"
          :pageSize="queryForm.size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '报销单号',
    dataIndex: 'numberNo',
    key: 'numberNo',
    align: 'center'
    // width: 80,
  },

  {
    title: '报销年度',
    dataIndex: 'year',
    key: 'year',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '批次号',
    dataIndex: 'batch',
    key: 'batch',
    ellipsis: true
  },

  {
    title: '门诊自付总额（元）',
    dataIndex: 'outpatientFee',
    key: 'outpatientFee',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '住院自付总额（元）',
    dataIndex: 'hospitalizationFee',
    key: 'hospitalizationFee',
    ellipsis: true,
    align: 'left'
  },

  {
    title: '审批状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' },
    ellipsis: true,
    align: 'left'
  },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    width: 180,
    align: 'left'
  }
]
// import { getDispositionList, deleteDisposition } from './api/api'
import { recallProcessFn } from '@/utils/utils'
import { pcMedicalReimbursementUserList, getYear } from './api/api'
export default {
  data() {
    return {
      expand: false,
      queryForm: {
        page: 1,
        size: 10
      },
      tableData: [],
      columns,
      total: 0,
      yearList: [],
      loading: false
    }
  },

  created() {
    this.getYearFn()
    this.getList()
  },
  methods: {
    // 年度下拉
    getYearFn() {
      getYear().then((res) => {
        if (res.data.code == 0) {
          this.yearList = res.data.data
        }
      })
    },
    // 提交 未审批 可撤回流程
    showRecallConfirm(record) {
      const recallProcessPromise = new Promise((resolve, reject) => {
        recallProcessFn(this, record, resolve, reject, 'd-fixe-dasset')
      })
      recallProcessPromise
        .then((value) => {
          console.log(value)
          this.getList()
        })
        .catch((error) => {
          console.log(error)
          this.getList()
        })
    },
    cancel() {
      //取消
      this.queryForm = {
        page: 1,
        size: 10
      }
    },
    subMit() {
      this.page = 1
      this.getList()
    },
    // 拉取列表
    getList() {
      this.loading = true
      pcMedicalReimbursementUserList(this.queryForm).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          deleteDisposition({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.getList()
            }
          })
        }
      })
    },
    add(type) {
      this.$router.push(`/MedicalFeeDetail?type=${type}`)
    },
    goDetial(record) {
      this.$router.push(
        '/MedicalFeeDetail?id=' + record.id + '&type=' + record.type
      )
    },
    pageChange(val) {
      this.queryForm.page = val
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  // justify-content: space-between;
  .query-top-select {
    // width: calc(100% - 200px);
    .query-cont {
      display: flex;
      align-items: center;
      // justify-content: space-between;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 20px 20px 0;
        .query-view-lable {
          // width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}
.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/MedicalFee/myMedicalFee.vue